/**
 * Wrapper that creates an Immediately Invoked Async Function Expression that executes and waits
 * for the promise returned by the passed in function.
 */
export const iiafe = (fn: () => Promise<void>, reject?: (err: any) => void) => {
  void (async () => {
    try {
      await fn();
    } catch (err: unknown) {
      console.error(err);
      reject?.(err);
    }
  })();
};
